export type AdminUserStatus = "pending" | "active" | "disabled";

export interface AdminUser {
  id: string;

  email: string | null;

  firstName: string;

  lastName: string;

  phone: string | null;

  roles: string[];

  status: AdminUserStatus;

  lastLoginAt: string | null;

  createdAt: string;
}

export interface AdminUsersListResponse {
  data: AdminUser[];

  total: number;
}

export interface CreateAdminUserInput {
  email: string;

  firstName: string;

  lastName: string;

  phone?: string;

  roles: string[];
}

export interface UpdateAdminUserInput {
  email?: string;

  firstName?: string;

  lastName?: string;

  phone?: string;

  roles?: string[];
}

export interface ActivateAdminInput {
  token: string;

  password: string;
}

export interface VerifyTokenResponse {
  valid: boolean;

  email?: string;

  firstName?: string;

  lastName?: string;
}

export const ADMIN_ROLES = {
  ADMIN: "admin",

  DEVELOPER: "developer",

  FOUNDER: "founder",
} as const;

export type AdminRole = (typeof ADMIN_ROLES)[keyof typeof ADMIN_ROLES];
